import React from 'react';
import {
  DialogTitle,
  DialogContent,
  DialogContentText,
  Dialog
} from '@material-ui/core';

const SuccessAlert = props => (
  <Dialog
    open={props.show}
    // onClose={this.handleClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <DialogTitle id="alert-dialog-title">{'Спасибо!'}</DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-description">
        Автор успешно добавлен в базу.
      </DialogContentText>
    </DialogContent>
  </Dialog>
);

export default SuccessAlert;



// WEBPACK FOOTER //
// ./src/components/SuccessAlert.jsx